<!--
 * @Description: 详情页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 07:28:56
 * @LastEditors: 山淑兰
-->
<template>
	<div class="details">
		<div class="loading" v-if="loading">
			<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
		</div>
		<div class="details-con">
			<!-- <div class="details-return"  @click="goBack()">
        <img src="../../../assets/back.png">  
      </div> -->
			<div class="details-con-main">
				<template v-if="$i18n.locale === 'zh-CN'">
					<!-- 头像部分 -->
					<div class="details-cons">
						<div class="details-head">
							<div class="guest-headimg" @click="viewPhoto()">
								<img :src="this.dataList.photo || this.defaultHeadImg" alt />
							</div>
							<div class="guest-top">
								<div class="guest-intro">
									<div class="guest-name">
										<span v-html="nToBr(this.dataList.cnname)"></span>
									</div>
									<div class="host" v-html="nToBr(this.dataList.cncompany)"></div>
								</div>
							</div>
							<div class="guest-close" @click="closeGuest">
								<img src="../../../assets/h-close.png">
							</div>
						</div>
						<ul class="details-tab">
							<li :class="{'active':tabShow1}" @click="getIntro()"
								v-if="introStatus && this.dataList.cnintroduction != '' && this.dataList.cnintroduction != null">
								{{ $t('meeting.details.guestsIntroductionTitle') }}</li>
							<li :class="{'active':tabShow2}" @click="getdetails()" v-if="programCount>0&&isshowprogram==0">
								学术任务({{programCount}})</li>
						</ul>
						<div id="guestIntroduction-con" v-if="tabShow1">
							<p v-html="this.dataList.cnintroduction"></p>
						</div>
						<div class="details-main" v-if="tabShow2">
							<div v-show="show == 'tasks'" v-for="(item, index) in list" :key="index">
								<div class="details-main-head">
									<van-cell :title="item[0].proDate" icon="send-gift-o"
										class="details-main-head-date" />
								</div>
								<van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
									<div class="meeting-list" v-if="i.url!=null">
										<div class="meeting-left">
											<van-cell icon="underway-o" class="major-titles">
												{{ i.startTime + '-' + i.endTime }} <span v-html="nToBr(i.topic)"></span>
											</van-cell>
											<a v-if="i.roomTitle || i.roomName">
												<van-cell icon="orders-o" class="major-title"
													:class="{ _link: i.url }">{{ i.roomTitle }}</van-cell>
												<van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">
													{{i.roomName }}</van-cell>
											</a>
											<van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
						  i.roleName
						}}</van-cell>
										</div>
										<div class="meeting-icon">
											<a :href="i.url" target="_top">
												<p><img src="../../../assets/creame3.png">
													观看直播</p>
											</a>
										</div>
									</div>
									<div class="meeting-list" v-if="i.url==null"
										@click="goMeeting($event,i.dateid,i.roomid,i.proid)">
										<div class="meeting-left">
											<van-cell icon="underway-o" class="major-title">
												{{ i.startTime + '-' + i.endTime }} <span v-html="nToBr(i.topic)"></span>
											</van-cell>
											<a v-if="i.roomTitle || i.roomName">
												<van-cell icon="orders-o" class="major-title"
													:class="{ _link: i.url }">{{ i.roomTitle }}</van-cell>
												<van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">
													{{i.roomName }}</van-cell>
											</a>
											<van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
						  i.roleName
						}}</van-cell>
										</div>
										<div class="meeting-icons">
											<img class="arrow" src="../../../assets/arrow-r.png">
										</div>
									</div>
								</van-cell>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<!-- 头像部分 -->
					<div class="details-cons">
						<div class="details-head">
							<div class="guest-headimg" @click="viewPhoto()">
								<img :src="this.dataList.photo || this.defaultHeadImg" alt />
							</div>
							<div class="guest-top">
								<div class="guest-intro">
									<div class="guest-name">
										<span>{{this.dataList.enname!=null&&this.dataList.enname!=''?this.dataList.enname:this.dataList.cnname}}</span>
									</div>
									<div class="host">
										{{this.dataList.encmpany!=null&&this.dataList.encmpany!=''?this.dataList.encmpany:this.dataList.cncompany}}
									</div>
								</div>
							</div>
							<div class="guest-close" @click="closeGuest">
								<img src="../../../assets/h-close.png">
							</div>
						</div>
						<ul class="details-tab">
							<li :class="{'active':tabShow1}" @click="getIntro()"
								v-if="introStatus && this.dataList.cnintroduction != '' && this.dataList.cnintroduction != null">
								{{ $t('meeting.details.guestsIntroductionTitle') }}</li>
							<li :class="{'active':tabShow2}" @click="getdetails()" v-if="programCount>0&&isshowprogram==0">
								Task({{programCount}})</li>
						</ul>
						<div id="guestIntroduction-con" v-if="tabShow1">
							<p v-html="this.dataList.enintroduction!=null&&this.dataList.enintroduction!=''?this.dataList.enintroduction:this.dataList.cnintroduction"></p>
						</div>
						<div class="details-main" v-if="tabShow2">
							<div v-show="show == 'tasks'" v-for="(item, index) in list" :key="index">
								<div class="details-main-head">
									<van-cell :title="item[0].proDate" icon="send-gift-o"
										class="details-main-head-date" />
								</div>
								<van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
									<div class="meeting-list" v-if="i.url!=null">
										<div class="meeting-left">
											<van-cell icon="underway-o" class="major-titles">
												{{ i.startTime + '-' + i.endTime }} 
												<span v-html="i.entopic!=null && i.entopic!='' ? nToBr(i.entopic) : nToBr(i.topic)"></span>
											</van-cell>
											<a v-if="i.roomEnTitle || i.roomEnName">
												<van-cell icon="orders-o" class="major-title"
													:class="{ _link: i.url }">
													{{ i.roomEnTitle!=null && i.roomEnTitle!='' ? i.roomEnTitle : i.roomTitle }}
												</van-cell>
												<van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">
													{{ i.roomEnName!=null && i.roomEnName!='' ? i.roomEnName : i.roomName }}
												</van-cell>
											</a>
											<van-cell class="major-title" icon="user-o" v-if="i.roleName">
												{{i.roleName}}
											</van-cell>
										</div>
										<div class="meeting-icon">
											<a :href="i.url" target="_top">
												<p><img src="../../../assets/creame3.png">
													观看直播</p>
											</a>
										</div>
									</div>
									<div class="meeting-list" v-if="i.url==null"
										@click="goMeeting($event,i.dateid,i.roomid,i.proid)">
										<div class="meeting-left">
											<van-cell icon="underway-o" class="major-title">
												{{ i.startTime + '-' + i.endTime }}
												<span v-html="i.entopic!=null && i.entopic!='' ? nToBr(i.entopic) : nToBr(i.topic)"></span>
											</van-cell>
											<a v-if="i.roomEnTitle || i.roomEnName">
												<van-cell icon="orders-o" class="major-title"
													:class="{ _link: i.url }">
													{{ i.roomEnTitle!=null && i.roomEnTitle!='' ? i.roomEnTitle : i.roomTitle }}
												</van-cell>
												<van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">
													{{ i.roomEnName!=null && i.roomEnName!='' ? i.roomEnName : i.roomName }}
												</van-cell>
											</a>
											<van-cell class="major-title" icon="user-o" v-if="i.roleName">
												{{i.roleName}}
											</van-cell>
										</div>
										<div class="meeting-icons">
											<img class="arrow" src="../../../assets/arrow-r.png">
										</div>
									</div>
								</van-cell>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		ImagePreview
	} from 'vant'
	import defaultHeadImg from '../../../assets/defaultHeadImg.png'

	export default {
		name: 'guestdetail',
		props: ['exid', 'introStatus'],
		data() {
			return {
				loading: false,
				programCount: 0,
				show: 'tasks',
				defaultHeadImg,
				list: {},
				dataList: [],
				tabShow1: true,
				tabShow2: false,
				gusetShow: false,
				isshowprogram: '',
			}
		},
		// watch: {
		//   $route(to, from) {
		//     if (to.query.exid != from.query.exid && to.query.exid) {
		//       this.exid = to.query.exid
		//       this.init()
		//     }
		//   },
		// },
		created() {
			this.init()
			this.init1()
			if (this.introStatus) {
				this.tabShow1 = true
				this.tabShow2 = false
			} else {
				this.tabShow1 = false
				this.tabShow2 = true
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			showCon(index) {
				if (index == 'tasks') {
					this.show = 'tasks'
				} else {
					this.show = 'guestIntroduction'
				}
			},

			formatTime(val) {
				let et = val.split('(')
				let end = et[1].split(')')[0]
				let endtime = Number(end)
				let date = new Date(endtime)
				let h = date.getHours()
				h = h < 10 ? '0' + h : h
				let m = date.getMinutes()
				m = m < 10 ? '0' + m : m
				return h + ':' + m
			},
			formatDate(val) {
				let et = val.split('(')
				let end = et[1].split(')')[0]
				let date = new Date(Number(end))
				let month = date.getMonth() + 1
				let day = date.getDate()
				return month + '-' + day
			},
			async init() {
				try {
					this.loading = true
					const {
						m
					} = this.$route.query
					const exid = this.exid
					console.log(exid)

					const _params = {
						m,
						exid
					}
					const PopupData = await this.$http.initScheduleInfo({
						m
					})
					this.$emit('searchDatas', PopupData.childens)

					const res = await this.$http.initGuestInfo(_params)

					// 头像卡片部分
					this.dataList = res.expert
					if (this.dataList.cnintroduction) {
						this.dataList.cnintroduction = this.dataList.cnintroduction.replace(
							/\n/g,
							'<br>'
						)
					}
					if (this.dataList.enintroduction) {
						this.dataList.enintroduction = this.dataList.enintroduction.replace(
							/\n/g,
							'<br>'
						)
					}
					if (this.dataList.cnintroduction == '' || this.dataList.cnintroduction == null || !this.introStatus) {
						this.tabShow1 = false
						this.tabShow2 = true
					} else {
						this.tabShow1 = true
						this.tabShow2 = false
					}
					console.log(this.dataList)
					
					if( res.DateListEntity.length > 0 ){
						for( let i in res.DateListEntity ){
							this.programCount += res.DateListEntity[i].ProgramCount
						}
					}
					
					let _list = []
					res.DateListEntity.map((item) => {
						let _k = []
						for (let i in item.programListEntity) {
							let _D = item.programListEntity[i]
							let {
								programList
							} = _D.programs
							for (let j in programList) {
								let _S = programList[j]
								console.log(_S)
								programList[j] = {
									url: _S.programRoom.url,
									proid: _S.proid,
									proDate: item.proDate,
									//中文
									createdTime: this.formatDate(_S.programDate.prodate),
									startTime: _S.starttime,
									endTime: _S.endtime,
									total: item.ProgramCount, //总数量
									pohto: res.expert.photo, //头像路径
									topic: _S.topic,
									roomName: _S.programRoom.roomname,
									roomTitle: _S.programRoom.roomtitle,
									roleName: _S.expertList[0].exrolemodel.rolename,
									dateid: _S.dateid,
									roomid: _S.roomid,
									//英文
									entopic: _S.entopic,
									roomEnName: _S.programRoom.roomenname,
									roomEnTitle: _S.programRoom.roomentitle,
									roleEnName: _S.expertList[0].exrolemodel.roleenname,
								}
								_k.push(programList[j])
							}
						}

						_list.push(_k)
					})

					this.list = _list
					console.log(this.list)
					this.loading = false
				} catch (err) {
					console.log(err)
				}
			},
			async init1() {
			    try {
			        const {
			            m,
			        } = this.$route.query //获得路由的参数
			        this.m = m
			
			        const _params = {
			            m: m
			        }
			        const res = await this.$http.initMeetingInfo(_params)
		
					this.isshowprogram = res.isshowprogram
			    } catch (error) {
			        console.error(error)
			    }
			
			    // this.$toast.clear(false); //关闭加载动画
			},
			//点击查看头像
			viewPhoto() {
				if (this.list.src) {
					ImagePreview({
						images: [this.list.src],
						startPosition: 0,
						onClose() {
							// do something
						},
						showIndex: false,
						closeOnPopstate: true,
					})
				}
			},
			goMeeting(e, dateid, roomid, proid) {
				console.log(proid)
				this.$emit("func", this.gusetShow)
				const params = {
					m: this.$route.query.m,
					roomid: roomid,
					dateid: dateid,
					top: proid,
				}
				this.$router.push({
					path: '/mpro/scheduleList',
					query: params,
				})
			},
			getIntro() {
				this.tabShow1 = true
				this.tabShow2 = false
			},
			getdetails() {
				this.tabShow1 = false
				this.tabShow2 = true
			},
			closeGuest() {
				this.$emit("func", this.gusetShow)
			},
			nToBr (str){
				if( str ){
					return str.replace(/\\n/g,'<br/>');
				}else{
					return str
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
    .details {
        --ink: #2c2c3a;
        --ink-light: #5a5a6e;
        --ink-muted: #8e8e9e;
        --accent: #2563eb;
        --accent-soft: #60a5fa;
        --bg: #f5f8fb;
        --card-bg: #ffffff;
        --border: #e2e8f0;
        --radius: 16px;
    }

    .loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1000;
    }

    .clicked {
        border-bottom: 1px solid #2563eb;
    }

    .details {
        .details-con {
            .details-return {
                position: fixed;
                right: 0;
                bottom: 80px;
                width: 84px;
                height: 60px;
                z-index: 100;
                background: #2563eb;
                border-radius: 16px 0 0 16px;
                text-align: center;
                line-height: 60px;
                color: #fff;

                img { height: 100%; }
            }

            .details-con-main {
                color: #2c2c3a;
                font-size: 28px;
            }

            .details-cons {
                background: #ffffff;
                margin-bottom: 20px;

                #guestIntroduction-con {
                    min-height: 300px;
                    margin-top: 20px;

                    >h4 {
                        font-size: 30px;
                        padding: 16px 20px;
                        height: 60px;
                        line-height: 60px;
                        display: flex;
                        color: #fff;
                        background: #2563eb;
                        border-radius: 12px 12px 0 0;
                    }

                    >p {
                        width: 100%;
                        padding: 20px 30px;
                        color: #5a5a6e;
                        line-height: 54px;
                        text-align: justify;
                        box-sizing: border-box;
                    }
                }
            }

            .details-head {
                position: relative;
                display: flex;
                padding: 20px;
                color: #2c2c3a;

                .guest-headimg {
                    text-align: center;
                    margin-right: 20px;
                    width: 160px;
                    height: 160px;
                    border-radius: 160px;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 160px;
                        border: 3px solid #e2e8f0;
                    }
                }

                .guest-top { flex: 1; }

                .guest-intro {
                    margin-top: 20px;
                    font-size: 28px;

                    .guest-name { font-size: 32px; font-weight: 700; }
                    .host, .guest-name { margin-top: 8px; }
                }

                .guest-close {
                    position: absolute;
                    right: 30px;
                    top: 30px;
                    width: 50px;
                    height: 50px;
                    background: #f5f8fb;
                    border-radius: 25px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img { display: block; width: 36px; height: 36px; }
                }
            }

            .details-tab {
                margin: 30px 0 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-bottom: 2px solid #e2e8f0;
                padding-bottom: 10px;

                li { padding: 0 30px; font-size: 28px; color: #8e8e9e; }

                li.active {
                    position: relative;
                    color: #2563eb;
                    font-weight: 600;
                }

                li.active:after {
                    position: absolute;
                    display: block;
                    content: '';
                    height: 4px;
                    left: 40px;
                    right: 40px;
                    bottom: -12px;
                    background: #2563eb;
                    border-radius: 2px;
                }
            }

            .details-title {
                margin: 20px 10px;
                font-size: 28px;
                color: #2c2c3a;

                span {
                    display: inline-block;
                    margin: 0px 18px;
                    line-height: 60px;
                    height: 60px;
                }

                &>div {
                    height: 30%;
                    font-size: 28px;

                    .synopsis .synopsis-tit {
                        height: 60px;
                        line-height: 60px;
                        background: #e2e8f0;
                        padding-left: 10px;
                    }
                }
            }

            .details-main {
                >div {
                    background: #ffffff;
                    margin-bottom: 24px;
                    border-bottom: 20px solid #f5f8fb;
                }

                .meeting-list {
                    display: flex;
                    margin-bottom: 10px;
                    padding: 10px 20px 10px 22px;
                    position: relative;

                    .meeting-left { flex: 1; }

                    .meeting-icon {
                        position: absolute;
                        right: 0;
                        top: 20px;
                        z-index: 10;
                        width: 160px;
                        display: flex;
                        align-items: flex-end;
                        justify-content: center;
                        background: #2563eb;
                        padding: 10px 0;
                        border-radius: 50px 0 0 50px;

                        a { color: #fff; display: block; text-align: center; }
                        img { width: 30px; vertical-align: -4px; }
                        p { font-size: 12px; }
                    }

                    .meeting-icons {
                        width: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;

                        a { color: #2c2c3a; display: block; text-align: center; }
                        img { width: 90px; }
                        img.arrow { width: 90%; }
                    }
                }

                .details-main-head {
                    display: flex;

                    .details-main-head-date {
                        color: #2563eb;
                        padding: 0px 0px 0px 20px;
                        font-size: 28px;

                        &>.van-icon { font-size: 40px; line-height: 40px; }
                        &:after { border: none; }
                        span { line-height: 40px; }
                    }

                    .van-cell { background: none; color: #2563eb; }
                }

                .details-main-con {
                    position: relative;

                    .major-title {
                        padding: 8px 0;
                        font-size: 26px;
                        color: #2c2c3a;
                        line-height: 36px;

                        >i { width: 36px; font-size: 36px; line-height: 36px; }
                        >div { color: #2c2c3a; }
                        &:after { border: 0px; }
                    }

                    .major-titles {
                        padding: 8px 160px 8px 0;
                        font-size: 26px;
                        color: #2c2c3a;
                        line-height: 36px;

                        >i { width: 36px; font-size: 36px; line-height: 36px; }
                        &:after { border: 0px; }
                    }
                }

                .details-main-con.van-cell { padding: 0; }
            }
        }

        ._link {
            >div { color: #2563eb !important; }
        }
    }
</style>
